<template>
  <div :class="_class">
    <div class="release-info-button-wrapper" :class="className">
      <a
        ref="button"
        role="button"
        class="release-info-button"
        :aria-label="buttonCaption"
        :aria-expanded="open ? 'true' : 'false'"
        :aria-controls="id ? id + '-release-info-panel' : null"
        tabindex="0"
        @click="toggle"
        @keydown.enter="toggle"
        @keydown.space="toggle"
      ></a>
    </div>
    <transition name="showpanel" @after-leave="afterLeave">
      <div
        v-if="open"
        :id="id ? id + '-release-info-panel' : null"
        class="release-info-panel"
        role="group"
        :aria-label="panelCaption"
      >
        <cat-btn
          ref="close"
          small
          icon="cancel"
          class="close-panel"
          :hint="panelCloseText"
          @ui-click="close"
        ></cat-btn>
        <div class="release-content">
          <slot></slot>
        </div>
        <span class="tip"></span>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },
  name: "CatReleaseInfo",
  props: {
    id: {
      type: [String, Number]
    },
    className: {
      type: String,
      description:
        "Class name to be added to the page help button wrapper markup."
    },
    title: {
      type: String,
      description:
        "Accessible name to be used to identify this release info component."
    },
    closeText: {
      type: String,
      description:
        "Label of the panel close button. Default text key is skin.help.panel.close if not present or 'Close'."
    }
  },
  data: function () {
    return {
      open: false
    };
  },
  computed: {
    _class: function () {
      return {
        "cat-release-info": true
      };
    },
    buttonCaption: function () {
      return this.title
        ? this.title
        : this.resolveTxt("skin.page.release.caption", "Release information");
    },
    panelCaption: function () {
      return this.panelTitle
        ? this.panelTitle
        : this.resolveTxt("skin.page.release.caption", "Release information");
    },
    panelCloseText: function () {
      return this.closeText
        ? this.closeText
        : this.resolveTxt("skin.help.panel.close", "Close");
    }
  },
  methods: {
    toggle: function (evt) {
      this.open = !this.open;
    },
    close: function () {
      this.open = false;
    },
    afterLeave: function () {
      jQuery(this.$refs.button).first().trigger("focus");
    }
  },
  mounted: function () {}
});
</script>
